<ng-container *transloco="let t">
  <form [formGroup]="inputForm">
    <!--    New organizer card-->
    <app-admin-card-with-title [cardTitle]="t('request.details')" [removeTopMargin]="true"
                               [isContentVisible]="!isRequestDetailsCollapsed"
                               [showToggleButton]="true">
      <div class="row">
        <div class="col-12 col-md-4 pb-3">
          <app-input formControlName="name"
                     label="{{t('organiser.details.name')}}" [readonly]="true"></app-input>
        </div>
        <div class="col-12 col-md-4 pb-3">
          <app-input formControlName="fullName"
                     label="{{t('organiser.details.full.name')}}" [readonly]="true"></app-input>
        </div>
        <div class="col-12 col-md-4 pb-3">
          <app-input formControlName="website"
                     label="{{t('organiser.details.web')}}" [readonly]="true"></app-input>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-4 pb-3">
          <app-input formControlName="email"
                     label="{{t('organiser.details.email')}}" [readonly]="true"></app-input>
        </div>
        <div class="col-12 col-md-4 pb-3">
          <app-input formControlName="phone"
                     label="{{t('organiser.details.phone')}}" [readonly]="true"></app-input>
        </div>
        <div class="col-12 col-md-4 pb-3">
          <app-input formControlName="address"
                     label="{{t('organiser.details.address')}}" [readonly]="true"></app-input>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-4 pb-3">
          <app-input formControlName="place"
                     label="{{t('organiser.details.place')}}" [readonly]="true"></app-input>
        </div>
        <div class="col-12 col-md-4 pb-3">
          <app-input formControlName="zip"
                     label="{{t('app.common.zip')}}" [readonly]="true"></app-input>

        </div>
        <div class="col-12 col-md-4 pb-3">
          <app-input formControlName="country"
                     label="{{t('app.common.country')}}" [readonly]="true"></app-input>
        </div>
      </div>
    </app-admin-card-with-title>
    <app-user-details-data [userDetails]="user" [basicDataTitle]="t('app.common.user')"/>
    <div class="d-flex py-4 align-items-center justify-content-end">
      <div class="pe-3">
        <app-rounded-button [label]="t('app.common.back')" [btnClass]="'rounded-button--button-black-solid'"
                            (onClick)="onCancel()"/>
      </div>
      @if (actionsAllowed()) {
        <app-rounded-button [label]="t('request.action.decline')" [btnClass]="'rounded-button--button-black-solid'"
                            (onClick)="openModifyRequestDialog(false)"/>
      } @else {
        <app-rounded-button [label]="t('request.action.accept')" (onClick)="openModifyRequestDialog(true)"/>
      }
    </div>
  </form>
</ng-container>
